var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 17.5C16.6668 15.1988 13.6821 13.3333 10.0002 13.3333C6.31826 13.3333 3.3335 15.1988 3.3335 17.5M10.0002 10.8333C7.69898 10.8333 5.8335 8.96785 5.8335 6.66667C5.8335 4.36548 7.69898 2.5 10.0002 2.5C12.3013 2.5 14.1668 4.36548 14.1668 6.66667C14.1668 8.96785 12.3013 10.8333 10.0002 10.8333Z",
    stroke: "#F7FAFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser02);
export default __webpack_public_path__ + "static/media/User_02.43edf9459323fbd6e0057642978bd23c.svg";
export { ForwardRef as ReactComponent };